module.exports = __webpack_public_path__ + "img/Searching_animato.b1b17afc.gif";